import { render } from "./PostModalContent.vue?vue&type=template&id=7cdd63e3"
import script from "./PostModalContent.vue?vue&type=script&lang=js"
export * from "./PostModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/PostModalContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cdd63e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cdd63e3', __exports__)) {
    api.reload('7cdd63e3', __exports__)
  }
  
  module.hot.accept("./PostModalContent.vue?vue&type=template&id=7cdd63e3", () => {
    api.rerender('7cdd63e3', render)
  })

}


export default __exports__